
import { ResellerOrder, WaitingPeriodStatus } from "@/types/resellerOrder";

// Export common types used across reseller order modules
export type ActivationResult = { 
  success: boolean; 
  message?: string; 
  licenseKey?: string; 
  accountNumber?: string;
  superAdminUrl?: string;
  credentials?: { email: string; password: string };
  testAccountCredentials?: { 
    admin: { email: string; password: string }; 
    user: { email: string; password: string } 
  };
};

export type PaymentVerificationResult = { 
  verified: boolean; 
  message?: string 
};

// In-memory storage retained ONLY for legacy screens still importing this module.
// Real reseller order data now lives in the `reseller_orders` Supabase table and is
// managed via the reseller-* edge functions (create, approve, activate, checkout).
export let resellerOrders: ResellerOrder[] = [];
